<style lang="scss" scoped>
    // Custom template positioning for the sorting arrows

    .my-admin__main {
        .table > thead > tr {

            .event-arrow-position {
                background-position-x: 55px;
            }

            .date-time-arrow-position {
                background-position-x: 125px;
            }

            .user-account-arrow-position {
                background-position-x: 100px;
            }

            .document-name-arrow-position {
                background-position-x: 123px;
            }

            .reviewed-by-arrow-position {
                background-position-x: 100px;
            }

            .status-arrow-position {
                background-position-x: 55px;
            }

            .comment-arrow-position {
                background-position-x: 80px;
            }

            .action-arrow-position {
                background-position-x: 55px;
            }
        }
    }

    .my-admin {
        .paginator {
            padding-left: 15px;
        }
    }

    .open > .dropdown-menu {
        margin-left: -109px;
        height: 180px;
        border-radius: 3px;
    }

    .task-history {
        padding-top: 3px;
    }

    @media only screen and (max-width: 1316px) and (min-width: 768px){
        .reviewed-by-arrow-position {
            background-position-x: 70px !important;
        }
    }
    @media only screen and (max-width: 1317px) and (min-width: 768px){
        .document-name-arrow-position {
            background-position-x: 75px !important;
        }
    }

    .my-admin table.tablesorter thead tr th.header {
        background-position: right center !important;
    }

    @media (max-width: 768px) {
        .my-admin {
            .second-group-buttons {
                width: 100%;
            }

            .dropdown-button {
                width: 100%;
            }

            .btn-group {
                width: 100%;
            }

            .open > .dropdown-menu-list {
                margin-left: 0;
                padding: 0;
                border: 1px solid rgba(0, 0, 0, .15);

                li {
                    text-align: center;
                }
            }

        }
    }

    .table-content-wrap {
        word-break: break-all;
        white-space: unset !important;
    }

    .comment-content-wrap {
        width: 200px;
    }

    .date-content-wrap {
        width: 180px;
    }

    .event-content-wrap {
        width: 180px;
    }

    .status-content-wrap {
        width: 100px;
    }

    .action-content-wrap {
        width: 120px;
    }

    .table {
        table-layout: auto;
    }
</style>

<template>
    <div class="my-admin my-admin__main">
        <top-bar active-item="admin"/>

        <div class="document-filter">
            <div class="my-admin__title">
                <h3 class="page-title my-admin__title-heading">My Admin</h3>
            </div>
            <div class="form-query form-inline">
                <div class="row">
                    <div class="col-md-12 col-sm-12 form-query__col">
                        <div class="form-group form-group__input">
                            <input type="text" name="q" v-model="q" @keydown.enter="querySearch" class="document-query"
                                   placeholder="Filter...">
                        </div>
                        <input type="hidden" name="prev-query">
                        <input type="hidden" name="tab" value="application-note">
                        <div class="form-group first-group-buttons">
                            <input type="button" class="btn btn-primary document-search" value="Search"
                                   @click="querySearch">
                            <input type="button" class="btn btn-primary document-reset" value="Reset" @click="reset">
                        </div>
                        <div class="form-group second-group-buttons">
                            <div class="btn-group">
                                <button
                                        type="button"
                                        class="btn btn-default dropdown-toggle btn btn-primary dropdown-button"
                                        data-toggle="dropdown" aria-haspopup="true"
                                        aria-expanded="false">
                                    Admin Tools
                                    <span class="caret"></span>
                                </button>
                                <ul class="dropdown-menu dropdown-menu-list">
                                    <li class="task-history"><a href="#" @click="downloadTasksHistoryInformation">Download
                                        Tasks History</a></li>
                                    <li role="separator" class="divider"></li>
                                    <li><a href="#" @click="downloadUsersInformation">Download User Information</a></li>
                                    <li role="separator" class="divider"></li>
                                    <li><a href="#" @click="downloadDocumentAccessInformation">Download Document
                                        Access</a></li>
                                    <li role="separator" class="divider"></li>
                                    <li><a href="#" @click="downloadUserBehavior">Download User Behavior</a></li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>

                <div v-if="results" class="row">
                    <Paginator
                            :paginatorId="'MyAdmin'"
                            :results="results"
                            :page="page"
                            :paginate="setPage"
                            :pageSizes="pageSizes"
                            v-on:pageSizeChange="setPageSize"
                    />
                </div>
            </div>
        </div>

        <div v-if="!results" class="document-table">No results available.</div>
        <div v-if="results > 0" class="document-table">
            <div class="table-responsive filter-results">
                <table class="table table-striped tablesorter documents">
                    <thead>
                    <tr>
                        <th class="header event-arrow-position" @click="sort('type')">Event</th>
                        <th class="header date-time-arrow-position" @click="sort('date')">Event date / time</th>
                        <th v-if="isSalesAdmin || isMyAmpleonSuperuser" class="header user-account-arrow-position" @click="sort('requestor')">
                            User account
                        </th>
                        <th v-if="isMarketingAdmin || isMyAmpleonSuperuser" class="header document-name-arrow-position"
                            @click="sort('documentName')">Document name
                        </th>
                        <th class="header reviewed-by-arrow-position" @click="sort('reviewer')">Reviewed by</th>
                        <th class="header status-arrow-position" @click="sort('status')">Status</th>
                        <th class="header comment-arrow-position" v-if="isMarketingAdmin || isMyAmpleonSuperuser" @click="sort('comment')">Comment</th>
                        <th v-if="!isMyAmpleonSuperuser" class="header action-arrow-position">Action</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr v-for="task in tasks">
                        <td class="table-content-wrap event-content-wrap">
                            {{task.type}}
                        </td>
                        <td class="table-content-wrap date-content-wrap">
                            {{task.date.toLocaleString()}}
                        </td>
                        <td v-if="isSalesAdmin || isMyAmpleonSuperuser" class="text-blue table-content-wrap">
                            {{task.requestor}}
                        </td>
                        <td v-if="isMarketingAdmin || isMyAmpleonSuperuser" class="text-blue table-content-wrap">
                            <a style="color: rgb(51, 122, 183)"
                               v-bind:href="task.document && task.document.documentLink">
                                {{task.document && task.document.documentName}}
                            </a>
                        </td>
                        <td class="text-blue table-content-wrap">
                            {{task.reviewedBy}}
                        </td>
                        <td class="table-content-wrap status-content-wrap">
                            {{task.status}}
                        </td>
                        <td class="table-content-wrap comment-content-wrap " v-if="isMarketingAdmin || isMyAmpleonSuperuser">
                            {{task.comment}}
                        </td>
                        <td v-if="task.type === 'User Registration' && !isMyAmpleonSuperuser"
                            class="action-column table-content-wrap">
                            <a style="color: #337AB7; cursor: pointer" @click="setModalData(task)" data-toggle="modal"
                               data-target="#userRegistrationModal">{{task.action}}</a>
                        </td>
                        <td v-if="task.type === 'Document approval' && !isMyAmpleonSuperuser"
                            class="action-column text-blue table-content-wrap action-content-wrap">
                            <a v-if="task.status !== 'Rejected'" style="color: #337AB7; cursor: pointer"
                               @click="setModalData(task)" data-toggle="modal" data-target="#documentApprovalModal">{{task.action}}</a>
                            &nbsp
                            <a v-if="task.status !== 'Rejected'" style="color: #337AB7; cursor: pointer"
                               @click="setModalData(task)" data-toggle="modal" data-target="#documentRejectionModal">Reject</a>
                        </td>
                    </tr>
                    </tbody>
                </table>

                <UserRegistrationModal/>
                <DocumentApprovalModal/>
                <DocumentRejectionModal/>

            </div>
        </div>
    </div>
</template>

<script>
    import {mapGetters} from 'vuex'
    import {
        FETCH_TASKS,
        OPEN_MODAL,
        DOWNLOAD_ALL_CUSTOMER_INFORMATION,
        DOWNLOAD_TASKS_HISTORY,
        DOWNLOAD_USER_BEHAVIOR,
        DOWNLOAD_DOCUMENT_ACCESS
    } from "../store/actions.type";
    import {QUERY_CHANGED} from "../store/mutations.type";
    import Paginator from './Paginator';
    import UserRegistrationModal from "./UserRegistrationModal";
    import DocumentApprovalModal from "./document-approval-tasks/DocumentApprovalModal";
    import DocumentRejectionModal from "./document-approval-tasks/DocumentRejectionModal";
    import TopBar from "./TopBar";

    export default {
        name: "MyAdmin",
        components: {
            UserRegistrationModal,
            DocumentApprovalModal,
            DocumentRejectionModal,
            Paginator,
            TopBar
        },
        data() {
            return {
                q: "",
                sortBy: "",
                orderBy: ["asc", "desc"],
                pageSizes: [10, 25, 50, 100],
                flushData: false
            };
        },
        computed: {
            ...mapGetters("myAdmin", ["tasks", "results", "page", "taskId", "requestor", "documentId"]),
            isSalesAdmin() {
                return this.$store.getters.isSalesAdmin;
            },
            isMarketingAdmin() {
                return this.$store.getters.isMarketingAdmin;
            },
            isMyAmpleonSuperuser() {
                return this.$store.getters.isMyAmpleonSuperuser;
            }
        },
        mounted() {
            this.commit(QUERY_CHANGED, {q: "", sort: "", order: "", status: "", page: 0, pageSize: this.pageSizes[0]});
            this.dispatch(FETCH_TASKS);
        },
        methods: {
            commit(mutation, payload) {
                return this.$store.commit('myAdmin/' + mutation, payload);
            },
            dispatch(action, payload) {
                return this.$store.dispatch('myAdmin/' + action, payload);
            },
            setCategory(category) {
                this.commit(QUERY_CHANGED, {category: category, page: 0});
                this.dispatch(FETCH_TASKS);
            },
            setPage(page) {
                this.commit(QUERY_CHANGED, {page: page - 1});
                this.dispatch(FETCH_TASKS);
            },
            setPageSize(pageSize) {
                this.commit(QUERY_CHANGED, {pageSize: parseInt(pageSize), page: 0});
                this.dispatch(FETCH_TASKS);
            },
            querySearch() {
                this.commit(QUERY_CHANGED, {q: this.q, sort: "", order: "", page: 0});
                this.dispatch(FETCH_TASKS);
            },
            reset() {
                this.q = "";
                this.commit(QUERY_CHANGED, {q: "", sort: "", order: "", page: 0});
                this.dispatch(FETCH_TASKS);
            },
            sort(by) {
                if (by !== this.sortBy) {
                    this.sortBy = by;
                    this.orderBy = ["asc", "desc"];
                }
                let order = this.nextOrder();
                if (!order) {
                    this.sortBy = "";
                }
                this.commit(QUERY_CHANGED, {sort: this.sortBy, order: order});
                this.dispatch(FETCH_TASKS);
            },
            nextOrder() {
                let next = this.orderBy.shift();
                this.orderBy.push(next);
                return next;
            },
            setModalData(task) {
                this.dispatch(OPEN_MODAL, {
                    taskId: task.id,
                    taskType: task.type,
                    requestor: task.requestor,
                    documentId: task.document && task.document.documentId
                });
            },
            downloadUsersInformation() {
                this.dispatch(DOWNLOAD_ALL_CUSTOMER_INFORMATION);
            },
            downloadTasksHistoryInformation() {
                this.dispatch(DOWNLOAD_TASKS_HISTORY);
            },
            downloadUserBehavior() {
                this.dispatch(DOWNLOAD_USER_BEHAVIOR);
            },
            downloadDocumentAccessInformation() {
                this.dispatch(DOWNLOAD_DOCUMENT_ACCESS);
            }
        }
    };
</script>


